import {
  BaseFieldProps,
  DetailStringUploadWidget,
  FormFieldWidget,
  ModelFieldType,
  RuntimeModelField,
  SPI,
  ViewType
} from '@kunlun/dependencies';
import Comp from './MyDetailFileFieldWidget.vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: [ViewType.Detail],
    model: ['deli.aries.seller.DeliAriesSellerSpecialApplyOrder'],
    name: 'attachmentUrls',
    ttype: [ModelFieldType.String, ModelFieldType.Text],
    widget: ['Upload']
  })
)
export class MyDetailFileFieldWidget extends DetailStringUploadWidget {
  initialize(props: BaseFieldProps<RuntimeModelField>): this {
    super.initialize(props);
    this.setComponent(Comp);
    return this;
  }
}
